import { Action, createReducer, on } from '@ngrx/store';
import { LoadStatus } from '../../load-status';
import { initUserMasterFailed, userMasterRestored, userSelected } from '../actions/user-master.actions';
import {
    initialUserMasterCollectionState,
    UserMasterCollectionState,
    UserMasterState,
} from '../user-master-collection.state';

const setSelectedUserReducer = (
    state: Readonly<UserMasterCollectionState>,
    { user }: { user: UserMasterState },
): Readonly<UserMasterCollectionState> => ({
    ...state,
    selectedUser: user,
    status: LoadStatus.Loaded,
});

const setFailedReducer = (state: Readonly<UserMasterCollectionState>): Readonly<UserMasterCollectionState> => ({
    ...state,
    status: LoadStatus.Error,
});

const createUserMasterReducer = createReducer(
    initialUserMasterCollectionState,
    on(userSelected, setSelectedUserReducer),
    on(userMasterRestored, setSelectedUserReducer),
    on(initUserMasterFailed, setFailedReducer),
);

export function userMasterReducer(
    state: Readonly<UserMasterCollectionState> | undefined,
    action: Action,
): Readonly<UserMasterCollectionState> {
    return createUserMasterReducer(state, action);
}
